export default __webpack_public_path__ + "static/media/p_wdt_c_0.05bb89a1.mp3";